const textDecorationFactory = (decoration, SEAT_WIDTH, SEAT_HEIGHT) => {
  const span = document.createElement("SPAN");
  const x = ((decoration.x * SEAT_WIDTH) - SEAT_WIDTH) + "px;";
  const y = ((decoration.y * SEAT_HEIGHT) - SEAT_HEIGHT) + "px;";
  span.style.cssText = `position: absolute; display: inline-block; left: ${x}; top: ${y}; line-height: 1; font-weight: 500;`;
  if (decoration.color) {
    span.style.color = decoration.color;
  }

  if (decoration.size) {
    span.style.fontSize = decoration.size;
  }
  span.innerText = decoration.value;
  return span;
};

const rectangleDecorationFactory = (decoration, SEAT_WIDTH, SEAT_HEIGHT) => {
  const span = document.createElement("DIV");
  const x = ((decoration.x * SEAT_WIDTH) - SEAT_WIDTH) + "px;";
  const y = ((decoration.y * SEAT_HEIGHT) - SEAT_HEIGHT) + "px;";
  const width = (decoration.width * SEAT_WIDTH) + "px;";
  const height = (decoration.height * SEAT_HEIGHT) + "px;";
  span.style.cssText = `position: absolute; left: ${x}; top: ${y}; width: ${width}px; height: ${height}px;`;
  if (decoration.color) {
    span.style.backgroundColor = decoration.color;
  }
  // span.innerText = decoration.value
  return span;
};

const measureElementSize = (el) => {
  const size = {};
  const $el = $(el).clone().hide().appendTo("body");
  size.width = $el.outerWidth();
  size.height = $el.outerHeight();
  $el.remove();
  return size;
};

const DecorationsDOMRender = {
  order: 0,
  run($$) {
    return $$.$.on("seats:rendering", () => {
      const fragment = document.createDocumentFragment();

      // draw stand seats
      ($$.seatsData.decorations || []).forEach((decoration) => {
        let el;
        $$.seatsWidth = Math.max($$.seatsWidth, decoration.x * $$.SEAT_WIDTH);
        $$.seatsHeight = Math.max($$.seatsHeight, decoration.y * $$.SEAT_HEIGHT);

        if (decoration.width) {
          $$.seatsWidth = Math.max($$.seatsWidth,
            (decoration.x + (decoration.width - 1)) * $$.SEAT_WIDTH);
        }
        if (decoration.height) {
          $$.seatsHeight = Math.max($$.seatsHeight,
            (decoration.y + (decoration.height - 1)) * $$.SEAT_HEIGHT);
        }

        if (decoration.type === "text") {
          el = textDecorationFactory(decoration, $$.SEAT_WIDTH, $$.SEAT_HEIGHT);
          const {
            width,
            height,
          } = measureElementSize(el);
          $$.seatsWidth = Math.max($$.seatsWidth, ((decoration.x - 1) * $$.SEAT_WIDTH) + width);
          $$.seatsHeight = Math.max($$.seatsHeight, ((decoration.y - 1) * $$.SEAT_HEIGHT) + height);
        } else if (decoration.type === "rectangle") {
          el = rectangleDecorationFactory(decoration, $$.SEAT_WIDTH, $$.SEAT_HEIGHT);
        }
        return fragment.appendChild(el);
      });

      return $$.$seats.append(fragment);
    });
  },
};

window.SectionDecorationsDOMRender = DecorationsDOMRender;

export default DecorationsDOMRender;
